export default function (editor, opts = {}) {
  const option = opts;
  const domc = editor.DomComponents;

  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType('change-passowrd-form', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: 'Change Password Form',
          droppable: ':not(form)',
          draggable: ':not(form)',
          method: '',
          action: '',
          traits: [
            {
              type: 'webconnect-event',
              label: false,
              name: 'onsubmit',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
        },
        init() {},
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'change-passowrd-form') {
            return {
              type: 'change-passowrd-form',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {},
    }),
  });
}
